import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {NgbPanelChangeEvent} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'number-selector',
  templateUrl: './number-selector.component.html',
  styleUrls: ['./number-selector.component.scss']
})
export class NumberSelectorComponent implements OnInit {
  @Input() count = 0;
  @Input() minNumber: number;
  @Input() maxNumber: number;
  @Input() seleniumName: string;
  @Output() onSelect: EventEmitter<number>;

  constructor() {
    this.onSelect = new EventEmitter<number>();
  }

  ngOnInit() {
  }
  increment() {
    if (this.count < this.maxNumber) {
      this.count++;
      this.onSelect.emit(this.count);
    }
  }
  decrement() {
    if (this.count > this.minNumber ) {
      this.count--;
      this.onSelect.emit(this.count);
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/number-selector/number-selector.component.ts